const { DISTRIBUTION_STATUS } = require('../constants/distribution');

const { INACTIVE } = DISTRIBUTION_STATUS;

const getCombinedDistributionStatus = (arr) => {
  if (!arr?.length) {
    return INACTIVE;
  }

  const statusArr = Object.values(DISTRIBUTION_STATUS);
  for (let i = 0; i < statusArr.length; i += 1) {
    if (arr.some((s) => s.status === statusArr[i])) {
      return statusArr[i];
    }
  }

  return INACTIVE;
};

module.exports = {
  getCombinedDistributionStatus,
};
